<template>
  <component
    :is="modal.component"
    v-for="modal in modals"
    :key="modal.id"
    :model-value="modal.isOpen"
    :class="$attrs['class']"
    @update:model-value="modal.setIsOpen"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useModalPlugin } from '../providers';

defineOptions({
  inheritAttrs: false,
});

const plugin = useModalPlugin();

const modals = computed(() => {
  return plugin.modals.value.filter((modal) => modal.component);
});
</script>
